var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.themeClass,attrs:{"id":"app"}},[_c('main-site'),(_vm.showLogo)?_c('logo',{staticClass:"app__logo"}):_vm._e(),_c('alert-socket'),_c('visibility-checker'),_c('title-changer'),_c('message-notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }